import {genCFDefChangeEventHandlerEpics} from 'module/CustomField/epic/GenCFDefChangeEventHandlerEpics'
import {Epic} from 'redux-observable'
import {CustomFieldTO} from 'generated/JavaTO'
import {Selector} from 'reselect'
import {CFMemberData, CFModel, CFSetOptions, CFValue} from 'module/CustomField/type/CFType'
import {PayloadActionCreator} from 'util/redux'
import {log} from 'common/log'
import {Module} from 'module/Module'
import {StTagModule} from 'module/StTag/StTagModule'
import {BSCollectionModule} from 'module/BSCollection/BSCollectionModule'
import {KostModule} from 'module/Kost/KostModule'
import {KontStammModule} from "module/KontStamm/KontStammModule";
import {CFGroupModule} from 'module/CFGroup/CFGroupModule'
import {MemoModule} from 'module/Memo/MemoModule'
import {AnyMatcher} from 'util/redux/matcher'
import {ClipboardModule} from 'module/Clipboard/ClipboardModule'
import {DqButtonModule} from 'module/DqButton/DqButtonModule'

/**
 * this module requires
 * - setUrlParamSelectorDict()
 * - genCFDefSpecificEpic() for change events
 *  **/
// this includes required Modules that may be used in parameters
export const CustomFieldModule: Module = {
	modules: [
		MemoModule,
		CFGroupModule,
		KostModule,
		KontStammModule,
		StTagModule,
		BSCollectionModule,
		ClipboardModule,
		DqButtonModule,
	],
}

export interface CFDefSpecificGeneratorParams {
	cfDefs: CustomFieldTO[]
	selModel: Selector<any, CFModel | undefined | null>
	setAttrAction: PayloadActionCreator<CFModel>
	setCFAction: PayloadActionCreator<{ cfDef: CustomFieldTO, value: CFValue | CFMemberData, options?: CFSetOptions }>
	changingActionsMatcher: AnyMatcher // all actions that could change the model
	closingActionsMatcher: AnyMatcher // matches any action, that closes the form, either saving successful, deleting successful or cancelling the dialog
}

/**
 * do a switchMap on comineEpics(...<return value>)(action$, state$, dep)
 *
 * this is just an alias function for finding it's entry point in CustomFieldModule
 */
export function genCFDefSpecificEpics(args: CFDefSpecificGeneratorParams): Epic[] {
	const cfDefChangeEpics = genCFDefChangeEventHandlerEpics(args)
	log.trace(`cfDef specific epics generated: [${cfDefChangeEpics.length}]`, cfDefChangeEpics)
	return cfDefChangeEpics
}